import { componentFactory } from 'vue-tsx-support';

import { JtnUiTypography } from '@jtnews/jtn-ui';
import { injectStylesMixin } from '@jtnews/shared';

import styles from './feedback-error.styles.scss?module';

export default componentFactory.mixin(injectStylesMixin(styles)).create({
  name: 'FeedbackError',
  render() {
    return (
      <JtnUiTypography class={styles.feedbackError} tag="div" type="font-vijet-type-3">
        Увидели опечатку? Выделите фрагмент и нажмите Ctrl+Enter
      </JtnUiTypography>
    );
  }
});
